<div
    [agprLoading]="loading"
    #chart
    class="agpr-donutChart"
    [ngStyle]="{'height': height + 'px'}"
></div>
